import React from "react";

const IEdit = ({
  color = "#252526",
  width = "12",
  height = "12",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M10.5208 10.9585C10.5208 11.3612 10.1944 11.6876 9.79167 11.6876H1.04167C0.638959 11.6876 0.3125 11.3612 0.3125 10.9585V2.20845C0.3125 1.80574 0.638959 1.47929 1.04167 1.47929H6C6.24162 1.47929 6.4375 1.67516 6.4375 1.91679C6.4375 2.15841 6.24162 2.35429 6 2.35429H1.1875V10.8126H9.64583V6.00012C9.64583 5.75849 9.84171 5.56262 10.0833 5.56262C10.325 5.56262 10.5208 5.75849 10.5208 6.00012V10.9585Z"
        fill={color}
      />
      <path
        d="M6.23111 4.72907L7.26231 5.76027L10.7684 2.2542L9.73718 1.223L6.23111 4.72907ZM7.26231 6.99771L4.99368 4.72907L9.22158 0.501166C9.50634 0.216408 9.96802 0.216408 10.2528 0.501166L11.4902 1.7386C11.775 2.02336 11.775 2.48504 11.4902 2.7698L7.26231 6.99771Z"
        fill={color}
      />
      <path
        d="M8.59118 1.75028L10.2411 3.4002L7.26231 6.37898L5.61239 4.72907L8.59118 1.75028Z"
        fill={color}
      />
      <path
        d="M7.57167 6.06964C7.74252 6.24049 7.74252 6.5175 7.57167 6.68835L6.74671 7.51331C6.68564 7.57439 6.60785 7.61601 6.52315 7.63295L4.46076 8.04543C4.31732 8.07411 4.16903 8.02923 4.0656 7.92579C3.96216 7.82236 3.91728 7.67407 3.94596 7.53063L4.35844 5.46824C4.37538 5.38354 4.417 5.30575 4.47808 5.24468L5.30304 4.41972C5.47389 4.24887 5.7509 4.24887 5.92175 4.41972L7.57167 6.06964ZM5.19065 5.76954L4.93285 7.05854L6.22185 6.80074L6.64359 6.37899L5.61239 5.3478L5.19065 5.76954Z"
        fill={color}
      />
      <path
        d="M10.459 3.18227C10.6299 3.35313 10.6299 3.63014 10.459 3.80099C10.2882 3.97184 10.0112 3.97184 9.8403 3.80099L8.19039 2.15107C8.01953 1.98022 8.01953 1.70321 8.19039 1.53236C8.36124 1.3615 8.63825 1.3615 8.8091 1.53236L10.459 3.18227Z"
        fill={color}
      />
    </svg>
  );
};

export default IEdit;
